import './footer.css';

import { FaFacebookSquare } from "react-icons/fa";
import { SlGlobe } from "react-icons/sl";
import { IoLogoYoutube } from "react-icons/io5";
import { FaInstagram } from "react-icons/fa";

export function Footer() {
    return (
        <footer>

            <div className="links">
                <div className="links-title">
                    <h5><span>Author:</span> Lasha Iarajuli</h5>
                </div>
                <div className="links-icons">
                    <h6>Contact Me:</h6>
                    <p><SlGlobe /></p>
                    <p><FaFacebookSquare /></p>
                    <p><FaInstagram /></p>
                    <p><IoLogoYoutube /></p>
                </div>
            </div>
        </footer>
    )
}